import React, {useEffect, useState} from "react";
import {useGroup} from "../contexts/GroupContext";
import {Box, FormControl, InputLabel, Select, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";

const AddresseeSwitchComponent = () => {

    const {selectedBot, setSelectedBot, botNames, botSerials, setSelectedSerial} = useGroup()
    const [isReady, setIsReady] = useState(false)
    const theme = useTheme()

    //Component is ready to render if all the groups are available
    useEffect(() => {
        if (selectedBot !== undefined && botNames.length !== 0) {
            if (selectedBot.length === 0) {
                setSelectedBot(botNames[botNames.length-1])
            }
            setIsReady(true)
        }
    }, [selectedBot, botNames, setSelectedBot])

    const handleBotSwitchChange = (event) => {
        //is index stored in event somewhere?
        let pos = botNames.indexOf(event.target.value);
        setSelectedBot(event.target.value);
        setSelectedSerial(botSerials[pos])
    };

    if (isReady) {
        return (
            <Box>
                <Box display="flex">
                    <Typography variant="h6" color={theme.palette.text.secondary}>Target which robot?</Typography>
                </Box>
                <FormControl fullWidth>
                    <InputLabel variant="custom" id="groupSwitchFieldLabel">Robot...</InputLabel>
                    <Select
                        labelId="groupSwitchFieldLabel"
                        id="groupSwitchField"
                        value={selectedBot}
                        label=""
                        onChange={handleBotSwitchChange}
                        variant={'standard'}
                        sx={{
                            ".MuiInputBase-input": {
                                color: theme.palette.custom.background
                            }
                        }}
                    >
                        {botNames.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
        );
    } else {
        return (
        <Box/>
        )
    }
}

export default AddresseeSwitchComponent